import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {ICopierRow} from './copiers'

// admin/copy/copier/:id 의 orders / leader_orders 행.
export interface ICopyOrder {
    id: string
    key_id: string
    type: string
    order_type: string
    exchange: string
    normalized_symbol: string
    price: number
    amount: number
    price_in_base: number
    fee: number
    pnl: number
    position_side: string
    created_at: number // unix 초
}

// 카피어 디테일에 딸려 오는 인보이스. 어드민 인보이스 페이지의 IInvoices와는 필드가 다르다.
export interface ICopierInvoice {
    id: string
    amount: number
    paid: number
    pnl: number
    status: string
    from_time: number // unix 초
    to_time: number // unix 초
    cut_percent: number
    created_at: number // unix 초
}

// 봇 설정 원본(JSON). 화이트리스트 키는 아래와 같고, 그 외 키도 그대로 실려 올 수 있다.
export interface ICopierSettings {
    leverage?: number
    max_leverage?: number
    fixed_balance?: number
    inverse?: boolean
    is_compound?: boolean
    mirror?: boolean
    start_clean?: boolean
    stop_loss?: number
    take_profit?: number
    force_multiple?: boolean
    [key: string]: any
}

// 주의: 목록과 달리 bot / bot_score가 비어 온다.
// 그래서 start_balance / deposit / withdraw / profit / earning은 이 응답에 없다.
export interface ICopierDetail extends ICopierRow {
    leader_id: string
    leader_key_id: string
    leader_name: string
    leader_thumbnail: string
    leader_exchange: string
    owed_earning: number
    settings?: ICopierSettings
    deleted_at?: string | null
    orders: ICopyOrder[]
    leader_orders: ICopyOrder[]
    invoices: ICopierInvoice[]
}

// pageSize는 orders / leader_orders 길이를 정한다(백엔드 기본 20, 최대 100).
export const getCopierDetail = async (id: string, pageSize: number = 100): Promise<ApiRes<ICopierDetail>> => {
    return await apiGet(API_URL, `admin/copy/copier/${id}?page_size=${pageSize}`)
}
